<template>
  <div
    class="
      common_wrap color_black relative
      pt_12 pb_12 pl_12 pr_12
    "
    :class="{
      bg_grey: !hasBind,
      bg_white: hasBind,
    }"
  >
    <template v-if="!hasBind">
      <div class="header">
        <div class="header_title mb_16">
          <p class="bold" style="text-indent: 0.8em;">完成<span class="main_text">角色绑定</span>可在公众号内参与更多活动~</p>
        </div>
        <div class="header_main card_wrap">
          <div class="header_guide card_head bold">输入<span class="main_text">角色ID</span>为您匹配角色信息:</div>
          <div class="header_oper card_main flex_center mt_12 mb_16">
            <div class="oper_label bold">角色ID:</div>
            <div class="oper_form" style="flex: 1; width: 0">
              <input
                type="text"
                placeholder="请输入角色ID"
                v-model="roleId"
              />
            </div>
            <div class="oper_btn">
              <van-button
                size="small"
                round
                color="linear-gradient(61deg, #658dfd 0%, #565ade 100%)"
                style="padding: 0 28px;"
                @click="handleGetRoleInfo"
              >
                <span class="bold">确认</span>
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <div class="body">
        <div class="body_main card_wrap">
          <div class="card_head flex_a_c">
            <span class="mr_8 bold">如何获取角色ID？参考下方图示</span>
            <img class="down_img" src="@/assets/bind/down.png" alt="">
          </div>
          <div class="card_main">
            <img style="width: 100%" v-if="rolePic" :src="rolePic" />
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="bind_success fs_16 mt_40">
        <div class="d_flex_col flex_a_c mb_20">
          <img style="width: 54px;" class="mb_16" src="@/assets/bind/done.png" />
          <p class="bold fs_18">
            已完成绑定
          </p>
        </div>
        <div class="bind_jump pl_12 pr_12">
          <van-button
            size="large"
            round
            color="linear-gradient(61deg, #658dfd 0%, #565ade 100%)"
            @click="handleJump"
          >
            点击领取礼包
          </van-button>
        </div>
      </div>
    </template>
    <Popup
      :visible.sync="visible"
      v-bind="feedback"
      :skins="{
        headerBg: 'linear-gradient(160deg, #565ade 0%, #658dfd 100%)'
      }"
      confirmButtonColor="#658DFD"
      @confirm="feedback.onSure"
    >
      <template v-if="feedbackType === 0">
        <div class="result">
          <div class="result_tip mb_16 text_center">
            匹配到以下角色信息：
          </div>
          <div class="result_info mb_16 fs_14">
            <div class="acc_item mb_12">
              <span class="bold">角色名: </span>{{ roleName }}
            </div>
          </div>
          <div class="result_confirm text_center bold mt_16 fs_16">
            是否确认绑定？
          </div>
        </div>
      </template>
    </Popup>
  </div>
</template>

<script>
import {
  getRoleBindInfo,
  getRoleInfoByRoleId,
  bindAccountApi,
} from '@/apis/common.api'
import Popup from '@/components/Popup.vue';
import trackingMixin, { EVENT_TYPE_ENUM } from "@/mixins/tracking"; 
import store from "@/store";
export default {
  components: {
    Popup,
  },
  mixins: [trackingMixin],
  data () {
    return {
      roleId: '',
      rolePic: '',
      hasBind: false,
      syUsername: '',
      roleName: '',
      uid: '',
      loading: false,
      feedbackType: 0,
      visible: false,
      gameId: '',
    }
  },
  mounted () {
    try {
      const params = JSON.parse(localStorage.getItem('wxAuthQuery'))
      this.gameId = this.$route.query.gameId || params.gameId
    } catch (error) {
      this.$toast('参数获取失败')
    }
    this.init()
  },
  computed: {
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    feedbackMap () {
      return [
        {
          title: '确认绑定',
          confirmButtonText: '确认绑定',
          message: [],
          onSure: () => {
            this.handleBind()
          }
        }
      ]
    },
  },
  methods: {
    init () {
      this.handleGetBindInfo().then(res => {
        this.EVENT_TRACKING(
          EVENT_TYPE_ENUM.wechat_role_bind_page,
          {
            type: this.hasBind ? 1 : 0
          }
        )
      })
    },
    // 获取绑定信号
    handleGetBindInfo () {
      return getRoleBindInfo({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
      }).then(res => {
        const { bind, rolePic, syUsername, uid } = res.data || {}
        this.hasBind = bind
        if (!bind) {
          // 引导绑定的图
          this.rolePic = rolePic
        } else if (syUsername) {
          this.syUsername = syUsername
          this.uid = uid
        }
      })
    },
    // 根据角色ID获取角色信息
    handleGetRoleInfo () {
      if (!this.roleId) {
        this.$toast('请输入角色ID')
        return
      }
      if (this.loading) return
      this.loading = true
      getRoleInfoByRoleId({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        roleId: this.roleId,
      }).then(res => {
        const { roleName, syUsername, uid } = res.data
        this.roleName = roleName
        this.syUsername = syUsername
        this.uid = uid
        this.triggerVisible(true, 0)
        this.EVENT_TRACKING(
          EVENT_TYPE_ENUM.wechat_role_info_pop,
          {
            role_id: this.roleId,
          }
        )
      }).finally(() => {
        this.loading = false
      })
    },
    handleBind () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_role_info_bind_button,
        {
          role_id: this.roleId,
        }
      )

      bindAccountApi({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        roleId: this.roleId,
        uid: this.uid,
      }).then(res => {
        this.triggerVisible(false)
        this.handleGetBindInfo()
      })
    },
    triggerVisible (v, type) {
      if (type !== undefined) {
        this.feedbackType = type
      }
      this.visible = v
    },
    // 跳转礼包中心
    handleJump () { 
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_role_to_gift_button,
        {
          uid: this.uid,
        }
      )
      this.$router.push({
        name: 'giftCenter',
        query: {
          tab: 1,
          gameId: this.gameId,
        }
      })
    },
  },
}
</script>

<style scoped lang='scss'>
.result {
  .result_tip {
    font-size: 16px;
    font-weight: bold;
  }
  .result_info {
    margin: 0 24px;
    padding: 24px;
    box-shadow: 0px 1px 6px 1px rgba(203,203,203,0.60); 
  }
}
.bind_success {
  padding: 46px 24px;
  .bind_account {
    padding: 32px 24px;
    background: #ffffff;
    box-shadow: 0px 1px 6px 1px rgba(203,203,203,0.60); 
  }
  .bind_tag {
    position: absolute;
    top: 12px;
    right: 12px;
    border-radius: 2px;
    border: 1px solid #999;
    padding: 3px;
  }
}

input {
  width: 100%;
  font-size: 12px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #e1e1e1;
  color: #5C5C5C;
  background-color: #f1f5ff;
  &:focus {
    border: 1px solid #565ADE;
  }
}

.main_text {
  font-size: 16px;
  color: #565ade;
  font-weight: bold;
}

.oper_form {
  padding: 0 8px;
}

.down_img {
  height: 24px;
}

.card_wrap {
  border-radius: 6px;
  background-color: #fff;
  padding: 8px 12px;
  margin-bottom: 10px;
  .card_head {
    line-height: 24px;
    padding-bottom: 4px;
    border-bottom: 1px solid #e1e1e18f;
  }
  .card_main {
    padding: 20px 0;
  }
}
</style>